import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { S3_URL_BASE } from 'src/environments/environment';
import { InputFileWithCommentCommentComponent } from '../input-file-with-comment/input-file-with-comment-comment/input-file-with-comment-comment.component';

@Component({
  selector: 'app-input-file-with-comment-and-date',
  templateUrl: './input-file-with-comment-and-date.component.html',
  styleUrls: ['./input-file-with-comment-and-date.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class InputFileWithCommentAndDateComponent implements OnInit, OnDestroy {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;

  @Input()
  mask: string;

  @Input()
  typeCes?: TypeCesEnum | undefined;

  // Eventos para o componente pai
  @Output() onFileClick = new EventEmitter<string>();
  @Output() onFileDelete = new EventEmitter<string>();

  formSub: Subscription;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.formSub = this.group.valueChanges.subscribe((value) => {
      if (!(value[this.config.name] instanceof File))
        this.fileName = value[this.config.name];
    });
  }

  ngOnDestroy(): void {
    this.formSub?.unsubscribe();
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  get messagesEnum() {
    return MessagesEnum;
  }

  @Input()
  requiredFileType: string;

  fileName = '';
  uploadProgress: number;
  uploadSub: Subscription;

  /**
   * Trunca o nome do arquivo para mostrar no máximo 30 caracteres
   * @param filename Nome do arquivo completo
   * @returns Nome truncado com reticências se necessário
   */
  truncateFileName(filename: string): string {
    if (!filename) return '';
    
    const maxLength = 30;
    
    if (filename.length <= maxLength) {
      return filename;
    }
    
    // Truncar o nome do arquivo e adicionar reticências
    return filename.substring(0, maxLength - 3) + '...';
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.fileName = file.name;
      this.group.get(this.config.name)?.setValue(file);
      this.group.get(`${this.config.name}Date`)?.setValue(new Date());
    }

    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: InputFileWithCommentCommentComponent,
      data: {
        type: TypeCesEnum.EDIT,
        element: this.group.get(`${this.config.name}Comment`)?.value,
      },
      callBack: async (data: any) => {
        if (data?.element) {
          this.group.get(`${this.config.name}Comment`)?.setValue(data.element);
        }
      },
    });
  }

  getFileUri() {
    return `${S3_URL_BASE}${this.group.get(this.config.name)?.getRawValue()}`;
  }

  public cancelFile() {
    const fileUrl = this.group.get(this.config.name)?.getRawValue();
    if (fileUrl) {
      this.onFileDelete.emit(fileUrl);
    } else {
      this.fileName = '';
      this.group.get(this.config.name)?.setValue('');
      this.group.get(`${this.config.name}Comment`)?.setValue('');
      this.group.get(`${this.config.name}Date`)?.setValue(null);
    }
  }

  public handleFileClick() {
    const fileUrl = this.group.get(this.config.name)?.getRawValue();
    if (fileUrl && typeof fileUrl === 'string') {
      const fullUrl = `${S3_URL_BASE}${fileUrl}`;
      window.open(fullUrl, '_blank');
      this.onFileClick.emit(fileUrl);
    }
  }

  public downloadFile() {
    return `${S3_URL_BASE}${this.group.get(this.config.name)?.getRawValue()}`;
  }

  public getComment() {
    return this.group.get(`${this.config.name}Comment`)?.value;
  }

  public getDate() {
    return this.group.get(`${this.config.name}Date`)?.value;
  }
}
